import React from 'react';
import auth from 'works/legacy/lib/auth';
import { useSetBreadcrumbs } from 'works/legacy/lib/client-store';
import { AppContent } from '@common/components';
import { MembersList } from '@identity/components';
import { ORGANIZATION_ADMIN_MENU } from 'works/pages/organization/admin-settings/organization-admin-vertical-nav-menu';
import { SUPPLIER_ADMIN_MENU } from 'works/pages/supplier/admin-settings/supplier-admin-vertical-nav-menu';

export function AdminMembersPage() {
  const entityType = auth.membershipType()?.toLocaleLowerCase() as
    | 'organization'
    | 'supplier';

  const breadcrumbStep =
    entityType === 'organization'
      ? {
          name: ORGANIZATION_ADMIN_MENU.USERS.LABEL,
          path: ORGANIZATION_ADMIN_MENU.USERS.ROUTE,
        }
      : {
          name: SUPPLIER_ADMIN_MENU.USERS.LABEL,
          path: SUPPLIER_ADMIN_MENU.USERS.ROUTE,
        };

  useSetBreadcrumbs([
    {
      name: 'Admin',
      path: '/works/admin',
    },
    breadcrumbStep,
  ]);

  return (
    <AppContent className="admin-members-page">
      <MembersList entityType={entityType} />
    </AppContent>
  );
}
